import type { Ordre } from "types/ordre";

/**
 * « Inconnu Alpha » : au transfert dans ServiceBox, le client n'a pas été trouvé dans
 * Alpha (DMS) — la fiche Alpha est née du transfert, souvent incomplète. La réception
 * devait jusqu'ici aller le vérifier dans Alpha elle-même (Lana, 2026-10-15).
 */
export default function AlphaUnknownBanner({ ordre, className = "" }: {
  ordre: Pick<Ordre, "alpha_client_unknown">;
  className?: string;
}) {
  if (!ordre.alpha_client_unknown) return null;
  return (
    <div
      className={`flex flex-row items-center gap-2 rounded-lg px-3 py-2 ${className}`}
      style={{ background: "#FFFBEB", border: "1px solid #FCD34D", fontFamily: "Poppins" }}
    >
      <span
        className="text-h4 font-bold"
        style={{ background: "#D97706", color: "#fff", borderRadius: 4, padding: "0 6px", whiteSpace: "nowrap" }}
      >
        Inconnu Alpha
      </span>
      <span className="text-h4" style={{ color: "#78350F" }}>
        Client absent d'Alpha au transfert ServiceBox : sa fiche Alpha vient d'être créée,
        à compléter dans Alpha (adresse, code postal, e-mail, véhicule).
      </span>
    </div>
  );
}
